<template>
  <div>
    <div class="outmain ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('set.payment.title') }}</span>
        </div>
      </div>

      <el-form ref="form" :model="form" label-width="180px" class="mar_t20">
        <el-form-item :label="$t('set.payment.normalMchId')" :required="true">
          <el-input
            v-model="form.mchId"
            :placeholder="$t('set.payment.normalMchIdPh')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.payment.normalMchKey')" :required="true">
          <el-input
            type="password"
            v-model="form.key"
            :placeholder="$t('set.payment.normalMchKeyPh')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('set.payment.certPem')" :required="true">
          <el-input
            type="textarea"
            v-model.trim="form.apiclient_cert"
            autocomplete="off"
            :placeholder="$t('set.payment.certPh')"
            rows="4"
          ></el-input>
          <div v-if="form.isCertfile == 1" class="subjectcolor2">{{ $t('set.payment.uploaded') }}</div>
          <div class="yb_margin lh16">
            {{ $t('set.payment.certTip') }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('set.payment.keyPem')" :required="true">
          <el-input
            type="textarea"
            v-model.trim="form.apiclient_key"
            autocomplete="off"
            :placeholder="$t('set.payment.certPh')"
            rows="4"
          ></el-input>
          <div v-if="form.iskeyfile == 1" class="subjectcolor2">{{ $t('set.payment.uploaded') }}</div>
          <div class="yb_margin lh16">
            {{ $t('set.payment.keyTip') }}
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from "@/api/set";

export default {
  created() {
    this.bus.$emit("loading", true);
    this.init();
  },
  data() {
    return {
      value: false,

      form: {
        mchId: "",
        key: "",
        apiclient_cert: "",
        apiclient_key: "",
        isCertfile: "",
        iskeyfile: "",
      },
    };
  },
  methods: {
    async init() {
      const { data } = await getConfig({ ident: "payConfig" });
      this.form = Object.assign({}, data);
      if (data.isCertfile == 1) {
        this.form.apiclient_cert = "";
      }
      if (data.iskeyfile == 1) {
        this.form.apiclient_key = "";
      }
      this.bus.$emit("loading", false);
    },

    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.ident = "payConfig";
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, "success");
          this.init();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style>
.orderpop p {
  line-height: 24px;
}

.msgtext {
  text-indent: -61px;
  padding-left: 70px;
}
</style>
